import * as actionType from "../constants/action_types";

const initialState = {
  list: [],
  loading: false,
  createdApp: null, // holds the one-time credentials response
  rotatedSecret: null,
};

export default function apps(state = initialState, action) {
  switch (action.type) {
    case actionType.FETCH_APPS_REQ:
      return { ...state, loading: true };
    case actionType.FETCH_APPS_RESPONSE:
      return { ...state, loading: false, list: Array.isArray(action.payload) ? action.payload : state.list };
    case actionType.CREATE_APP_RESPONSE:
      return { ...state, createdApp: action.payload };
    case actionType.ROTATE_APP_SECRET_RESPONSE:
      return { ...state, rotatedSecret: action.payload };
    default:
      return state;
  }
}
